export default function ChoiceGate() {
    // Variables to determine if we should clear the session cache for sites with gates
    let isInternalNavigation = false;
    let isPageReload = false;

    document.body.addEventListener('click', e => {
        const link = e.target.closest('a');

        if (!link) return;

        const href = link.getAttribute('href');

        if (href && (href.startsWith('/') || href.includes(window.location.hostname))) {
            isInternalNavigation = true;
            // Reset this flag after a short delay in case the navigation doesn't happen
            setTimeout(() => { isInternalNavigation = false; }, 1000);
        }
    });
    window.addEventListener('beforeunload', async () => {
        if (performance) {
            // Check if it's a reload by examining the performance navigation type
            if (performance.navigation) {
                isPageReload = performance.navigation.type === 1; // 1 is TYPE_RELOAD
            } else if (performance.getEntriesByType && performance.getEntriesByType('navigation').length) {
                // Newer API
                isPageReload = (performance.getEntriesByType('navigation')[0].type === 'reload');
            }
        }

        if (!isInternalNavigation && !isPageReload) {
            await fetch('/actions/forms-module/forms/clear-gate', { keepalive: true });
        }
    });
}
